<template>
  <div class="c-progress">
    <div class="c-progress__label">
      <span>{{ value }} van {{ max }} {{ label }} {{finishedlabel}}</span>
      <span v-if="secondlabel!=''" class="right">{{ secondvalue }} {{secondlabel}}</span>
    </div>

    <div class="c-progress__bar">
      <div class="c-progress__track" :style="{ transform: `scaleX(${value / max})` }"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    label: {
      type: String,
      default: 'trends'
    },
    finishedlabel: {
      type:String,
      default: 'doorlopen'
    },
    secondvalue: {
      type: Number,
      default: 0
    },
    secondlabel: {
      type:String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.c-progress {
  height: 4.8rem;
  padding-top: 1.2rem;
  position: relative;
}

.c-progress__label {
  line-height: 1.6rem;
}

.c-progress__bar {
  background: rgba(#FFF, 0.5);
  bottom: 0;
  height: 2px;
  left: 0;
  position: absolute;
  right: 0;
}

.c-progress__label .right {
    float: right;
}

.c-progress__track {
  background: #FFF;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transform: scaleX(0);
  transform-origin: 0 0;
}
</style>
